import { writable, get } from 'svelte/store';
import debounce from 'lodash/debounce'

export let currentPage = writable();
export let allPages = [];
export let showNext = writable('false');
export let showPrev = writable('false');

function createPaging() {
    const { subscribe } = writable(0);


    return {
        subscribe,
        init: () => {
            const hash = window.location.hash.substr(1);

            if (!load(hash)) {
                load(allPages[0]);
            }
        },
        prev: () => {
            let index = getPageIndex(),
                prev = allPages[
                    Math.max(0,
                        Math.min(index - 1, allPages.length - 1)
                    )];
            load(prev);
        },
        next: () => {
            let index = getPageIndex(),
                next = allPages[
                    Math.max(0,
                        Math.min(index + 1, allPages.length - 1)
                    )];
            load(next);
        },
        load: (page) => {
            load(page);
        },
        addPage: (page) => {
            allPages.push(page);
        },
        showPrev: (bool) => {
            showPrev.set(bool == true);
        },
        showNext: (bool) => {
            showNext.set(bool == true);
        }
    }
}

export const pagingStore = createPaging();

const load = (page) => {
    if (pageExists(page)) {
        if (page !== get(currentPage)) {
            currentPage.set(page);
            window.location.hash = page;
        }
        return true;
    } else {
        return false;
    }
}

function getPageIndex(page) {
    if (undefined === page) {
        return allPages.indexOf(get(currentPage));
    } else {
        return allPages.indexOf(page);
    }
}

function pageExists(page) {
    let foo = getPageIndex(page) >= 0;
    return foo;
}

window.onhashchange = () => {
    let hash = window.location.hash.substr(1);
    load(hash);
};

const arrowKeys = debounce( e => {
    if (e.keyCode == '37' && get( showPrev ) ) {
        pagingStore.prev();
    }
    else if (e.keyCode == '39'  && get( showNext ) ) {
        pagingStore.next();
    }
}, 300, {
    'leading': true,
    'trailing': false,
    'maxWait': 3000
});

window.addEventListener('keydown', arrowKeys);